import {HttpErrorResponse} from '@angular/common/http';
import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {DistributionAccount} from '../../../../distribution-account/distribution-account.model';
import {MultiShareValidationService} from '../../../../segment-multi-share/multi-share-validation.service';
import {SubscriptionHandler} from '../../../../utils/subscription-handler';
import {
  ActiveAgentAttribute,
  ActiveAgentAttributePriceModel,
  ActiveAgentService,
  ActiveAgentTaggingAttributes,
  ShareToAttributeRequest
} from './active-agent.service';
import {SegmentRemoveShareDialogComponent} from '../../../share/remove-share-dialog.component';
import {ActiveAgentShareConfig} from '../../../../segment-multi-share/segment-share.service';

@Component({
  selector: 'app-segment-info-target-active-agent',
  templateUrl: './active-agent.component.html',
  styleUrls: ['../account/account.component.scss', './active-agent.component.scss']
})
export class SegmentInfoAccountActiveAgentComponent implements OnInit, OnDestroy {

  @Input() account!: DistributionAccount;
  @Output() priceChange = new EventEmitter<ActiveAgentShareConfig>();

  attributePrices: ActiveAgentAttributePriceModel[] = [];
  attributes: ActiveAgentTaggingAttributes[] = [];

  newActiveAgentAttributeId?: number;
  newCpmInCent?: string;
  sendingCreate = false;
  createError!: HttpErrorResponse;

  error: string | undefined;
  dialogRef!: MatDialogRef<SegmentRemoveShareDialogComponent>;
  isDryMode = false;
  readonly billableAccounts: string[] = ['3501'];
  private subscriptionHandler = new SubscriptionHandler();

  constructor(private activeAgentService: ActiveAgentService,
              private dialog: MatDialog,
              private validation: MultiShareValidationService) {
  }

  ngOnInit() {
    this.isDryMode = !this.account.segmentId;

    this.subscriptionHandler.subscription = this.activeAgentService
      .getTaggingAttributes(this.account.id)
      .subscribe((data) => this.attributes = data);
    if (!this.isDryMode) {
      this.reloadPrices();
    }
    this.sendValidation();
  }

  ngOnDestroy() {
    this.subscriptionHandler.unsubscribe();
  }

  public createAttributePrice() {

    const shareToAttribute: ShareToAttributeRequest = {
      accountId: this.account.id,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      segmentId: this.account.segmentId!!,
      activeAgentAttributeId: this.newActiveAgentAttributeId as number,
      cpmInCent: (Number(this.newCpmInCent)) * 100
    };

    if (this.isDryMode) {
      this.attributePrices.push(
        {
          attributeName: this.attributes.find(a => a.id === shareToAttribute.activeAgentAttributeId)?.name,
          cpmInCent: shareToAttribute.cpmInCent || null
        } as ActiveAgentAttributePriceModel);
      this.emitChange();
    } else {
      this.sendingCreate = true;
      this.subscriptionHandler.subscription = this.activeAgentService.shareToAttribute(shareToAttribute)
        .subscribe((data: any | HttpErrorResponse) => {
          this.sendingCreate = false;
          if (data instanceof HttpErrorResponse) {
            this.createError = data;
          } else {
            delete this.newActiveAgentAttributeId;
            delete this.newCpmInCent;
            this.reloadPrices();
          }
        });
    }
  }

  reloadPrices() {
    this.subscriptionHandler.subscription = this.activeAgentService
      .getAttributePrices(this.account.id, this.account.segmentId)
      .subscribe({
        next: res => {
          this.attributePrices = res;
        },
        error: (error) => {
          this.error = `Error: Could not fetch prices. (${error.status})`;
        }
      });
  }

  openDeleteShareDialog() {
    const config = new MatDialogConfig();
    this.dialogRef = this.dialog.open(SegmentRemoveShareDialogComponent, config);
    this.dialogRef.componentInstance.account = this.account;
  }

  dryDrop(attributePrice: ActiveAgentAttributePriceModel) {
    const idx = this.attributePrices.findIndex(x => attributePrice === x);
    this.attributePrices.splice(idx, 1);
    this.emitChange();
  }

  hasDuplicate(attributeId: number): boolean {
    const attributeName = this.attributes.find(search => search.id === attributeId)?.name;
    return !this.attributePrices.find(search => search.attributeName === attributeName);
  }

  isBillable(): boolean {
    return this.billableAccounts.includes(this.account.foreignAccountId);
  }

  private sendValidation() {
    this.validation.notifyValidate({
      valid: this.attributePrices.length > 0,
      key: `activeAgent_${this.account.id}`,
      hint: `Add at least one attribute for: ${this.account.description}`
    });
  }

  private emitChange() {
    this.priceChange.emit({
      attributes: this.attributePrices.map(a => {
        return {
          clientId: this.attributes.find(x => x.name === a.attributeName)?.id,
          cost: a.cpmInCent
        } as ActiveAgentAttribute;
      })
    } as ActiveAgentShareConfig);
    this.sendValidation();
  }
}


